namespace RioERP.Masters {
    export namespace SmsGatewaySettingsService {
        export const baseUrl = 'Masters/SmsGatewaySettings';

        export declare function Create(request: Serenity.SaveRequest<SmsGatewaySettingsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SmsGatewaySettingsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SmsGatewaySettingsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SmsGatewaySettingsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Masters/SmsGatewaySettings/Create",
            Update = "Masters/SmsGatewaySettings/Update",
            Delete = "Masters/SmsGatewaySettings/Delete",
            Retrieve = "Masters/SmsGatewaySettings/Retrieve",
            List = "Masters/SmsGatewaySettings/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SmsGatewaySettingsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
